import { defineComponent as o, createElementBlock as r, openBlock as l, renderSlot as n, createElementVNode as a } from "vue";
const i = { class: "overlay-layout" }, m = /* @__PURE__ */ o({
  __name: "Overlay",
  emits: ["click"],
  setup(s) {
    return (e, t) => (l(), r("div", i, [
      n(e.$slots, "default", {}, void 0, !0),
      a("div", {
        "aria-hidden": "true",
        class: "overlay-backdrop",
        onClick: t[0] || (t[0] = (c) => e.$emit("click"))
      })
    ]));
  }
});
export {
  m as default
};
